import serviceRequest from "utils/request";

const baseUrl = "/api/outputRequest";

export const updateOutputRequest = (param) => {
	return serviceRequest({
		url: `${baseUrl}/update-output-request`,
		method: "post",
		data: param,
	});
};

export const updateOutputRequestRes = (param) => {
	return serviceRequest({
		url: `${baseUrl}/update-output-request-res`,
		method: "post",
		data: param,
	});
};

export const getOutputUserProjects = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-user-projects`,
		method: "get",
		params,
	});
};

export const getOutputRequests = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-output-requests`,
		method: "get",
		params,
	});
};

export const getOutputRequestsRes = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-output-requests-res`,
		method: "get",
		params,
	});
};

export const getOutputRequestDetail = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-output-request-detail`,
		method: "get",
		params,
	});
};

export const getOutputStatement = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-form-statement`,
		method: "get",
		params,
	});
};

export const getOutputChecklist = (params) => {
	return serviceRequest({
		url: `/ref/output/checklist/query`,
		method: "get",
		params,
	});
};

export const getRecentEthicsApprovalFiles = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-recent-ethics-approval-files`,
		method: "get",
		params,
	});
};

export const getRecentSupportingFundingDocumentsFiles = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-recent-supporting-funding-documents`,
		method: "get",
		params,
	});
};
